import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class CategoriesService {
  fetchCategories = (params) => {
    return fetch(config.config.endpointUrls.fetchCategories(params), {
      method: 'GET'
    })
  }
}

export default new CategoriesService()



// WEBPACK FOOTER //
// ../src/services/categoriesService/categoriesService.js